import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../../Layout/Layout";

export default function PageShell({ title, subtitle, actions, children }) {
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS accounts-page">
            <div className="accounts-page-head">
              <div>
                <h2 className="mainTitle">{title}</h2>
                {subtitle ? <p className="subText">{subtitle}</p> : null}
              </div>
              {actions ? <div className="accounts-page-actions">{actions}</div> : null}
            </div>
            {children}
          </div>
        </Col>
      </Row>
    </main>
  );
}
